<template>
    <div class="d-flex mb16" :class="{ 'justify-content-start': isMobile, 'justify-content-end': !isMobile }">
        <Icon v-if="!isMobile" name="close" size="c24" class="pointer" @click="close" />
        <Icon v-else name="arrow-left" size="c24" class="pointer" @click="close" />
    </div>
    <div class="d-flex align-items-center bg-white rounded12 p16" :class="{'flex-column-reverse justify-content-center': isMobile, 'justify-content-between': !isMobile}">
        <div class="wheel-container" :class="{'mr-0': isMobile, 'mr24 my14': !isMobile}">
            <div class="wheel-container-inner"></div>
            <div class="canvas-wrapper">
                <canvas ref="wheelCanvas" width="228" height="228"></canvas>
            </div>
            <div class="indicator">
                <svg width="21" height="32" viewBox="0 0 21 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.1238 3.01045L12.0084 30.3465C11.5518 31.8848 9.37317 31.8847 8.9165 30.3465L0.801112 3.01045C0.514048 2.0435 1.17513 1.0533 2.17825 0.947706L10.4625 0.0756836L18.7467 0.947706C19.7498 1.0533 20.4109 2.0435 20.1238 3.01045Z" fill="url(#paint0_linear_2769_16399)"/>
                    <defs>
                        <linearGradient id="paint0_linear_2769_16399" x1="10.4625" y1="5.05793" x2="10.4625" y2="40.9833" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#FEDC31"/>
                            <stop offset="0.09" stop-color="#FDC347"/>
                            <stop offset="0.27" stop-color="#FC8682"/>
                            <stop offset="0.52" stop-color="#FA2CD7"/>
                            <stop offset="0.76" stop-color="#987CDB"/>
                            <stop offset="1" stop-color="#33D0E0"/>
                        </linearGradient>
                    </defs>
                </svg>
            </div>
        </div>
        <div class="d-flex flex-column align-items-center w248" :class="{ 'mb24 my14': isMobile }">
            <div class="mb16">
                <img src="@/assets/test-money.png" alt="gift">
            </div>
            <div v-if="!spinned" class="text-center mb8 fsp28 lh34 neue blue-color">
                <div>{{ $t('components.service.modal.TestMoney.2') }}</div>
            </div>
            <div v-else class="mb8">
                <div class="text-center fsp32 lh34 neue blue-color">
                    <div>{{ $t('components.service.modal.TestMoney.3') }}</div>
                    <div class="d-flex align-items-center justify-content-center">{{ result.text }} <Icon name="test-coin" size="c26" class="ml4 mt4" /></div>
                </div>
            </div>
            <p v-if="!spinned" class="text-center text-black lh20 text-black neue-roman mb-0 fsp14">{{ $t('components.service.modal.TestMoney.4') }}</p>
            <div v-else class="text-center text-black lh20 text-black neue-roman">
                <p class="mb-0 fsp14">{{ $t('components.service.modal.TestMoney.5') }} {{ $t('components.service.modal.TestMoney.6') }}</p>
            </div>
            <div v-if="!spinned" :class="{ 'position-fixed bottom-0 left-0 end-0 border-t px24 py16 bg-white w-100': isMobile, 'mt24 mb14': !isMobile }">
                <Button :name="$t('components.service.modal.TestMoney.7')" type="btn-success" class="h40" :class="{'w-100': isMobile, 'w192': !isMobile}" :disabled="isSpinning" @click="spin" />
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/icons/Icon.vue';
import Button from '@/components/service/Button.vue';

export default {
    name: 'TestMoney',
    components: {
        Icon,
        Button,
    },
    props: {
        close: [Function],
    },
    data() {
        return {
            result: '',
            duration: 5000,
            curr_code: this.$store.state.modal.content.curr_code,
            currentRotation: 0,
            isSpinning: false,
            spinned: false,
            segments: [
                { value: 100000, colors: ['#FFEB1C', '#FED319', '#FC9512'], text: '100 000' },
                { value: 150000, colors: ['#2FFFFF', '#2AE7FF', '#1EA9FF', '#1A95FF'], text: '150 000' },
                { value: 200000, colors: ['#CC0A60', '#E60C69', '#FE0E73'], text: '200 000' },
                { value: 300000, colors: ['#7815FC', '#600FF4', '#3D08EA'], text: '300 000' },
                { value: 400000, colors: ['#00CBA2', '#00B392', '#006F67'], text: '400 000' },
                { value: 500000, colors: ['#B5B5B5', '#9D9D9D', '#808080'], text: '500 000' },
                { value: 750000, colors: ['#FC9512', '#FC7B10', '#FE3E0E', '#FF260D'], text: '750 000' },
                { value: 1000000, colors: ['#FFCC0F', '#FE9115', '#FE7A18'], text: '1Million' },
            ],
            canvas: null,
            ctx: null,
            centerX: 114,
            centerY: 114,
            radius: 109
        }
    },
    mounted() {
        this.initCanvas();
        this.drawWheel();
    },
    computed: {
        isMobile() {
            return this.$store.state.resize.w <= 768;
        }
    },
    watch: {
        result: {
            handler() {
                if(this.result) {
                    this.claim();
                }
            },
        }
    },
    methods: {
        initCanvas() {
            this.canvas = this.$refs.wheelCanvas;
            this.ctx = this.canvas.getContext('2d');
        },
        drawWheel() {            
            // Рисуем внешний круг
            this.ctx.save();
            this.ctx.translate(this.centerX, this.centerY);
            this.ctx.rotate(this.currentRotation * Math.PI / 180);
            
            // Рисуем сегменты
            const segmentAngle = 2 * Math.PI / this.segments.length;
                this.segments.forEach((segment, index) => {
                    const startAngle = index * segmentAngle - Math.PI / 2; // Смещаем на -90 градусов, чтобы 0 был сверху
                    const endAngle = startAngle + segmentAngle;
                    
                    //console.log(`Segment ${index}: ${segment.text} - Angle: ${(startAngle * 180 / Math.PI).toFixed(1)}° to ${(endAngle * 180 / Math.PI).toFixed(1)}°`);
                    // Создаем градиент для сегмента
                    const gradient = this.ctx.createRadialGradient(0, 0, 0, 0, 0, this.radius + 2);
                
                    const colors = segment.colors;                 
                    for (let i = 0; i < colors.length; i++) {
                        const stop = i / (colors.length - 1);
                        gradient.addColorStop(stop, colors[i]);
                    }
                    
                    // Рисуем сегмент
                    this.ctx.beginPath();
                    this.ctx.moveTo(0, 0);
                    this.ctx.arc(0, 0, this.radius + 2, startAngle, endAngle);
                    this.ctx.closePath();
                    this.ctx.fillStyle = gradient;
                    this.ctx.fill();
                    
                    // Рисуем текст
                    this.ctx.save();
                    this.ctx.rotate(startAngle + segmentAngle / 2);
                    this.ctx.textAlign = 'center';
                    this.ctx.textBaseline = 'middle';
                    this.ctx.fillStyle = '#fff';
                    this.ctx.font = 'normal 16px HelveticaNeue';
                    this.ctx.fillText(segment.text, this.radius * 0.55, 0); // Приблизил текст к центру
                    
                    // Рисуем иконку монеты рядом с текстом
                    const iconX = this.radius * 0.55 + 30;
                    const iconY = -7;
                    this.drawCoinIcon(iconX, iconY, 14);
                    
                    this.ctx.restore();
                });
            
                this.ctx.restore();
        },
        drawCoinIcon(x, y, size = 16) {
            this.ctx.save();
            this.ctx.translate(x, y);
            this.ctx.scale(size / 25, size / 26); // Масштабируем под размер
            
            // Внешний круг с градиентом
            this.ctx.beginPath();
            this.ctx.arc(12.5, 13, 11.5, 0, 2 * Math.PI);
            
            // Создаем градиент для фона
            const gradient = this.ctx.createRadialGradient(12.5, 13, 0, 12.5, 13, 11.5);
            gradient.addColorStop(0, '#FFF4D3');
            gradient.addColorStop(1, '#FFF4D3');
            this.ctx.fillStyle = gradient;
            this.ctx.fill();
            
            // Обводка с пунктиром
            this.ctx.strokeStyle = '#FEAE32';
            this.ctx.lineWidth = 1;
            this.ctx.setLineDash([0.1, 4]);
            this.ctx.stroke();
            this.ctx.setLineDash([]);
            
            // Внутренний круг с градиентом
            this.ctx.beginPath();
            this.ctx.arc(12.5, 13, 9, 0, 2 * Math.PI);
            
            const innerGradient = this.ctx.createLinearGradient(3, 12, 16.4, 12);
            innerGradient.addColorStop(0, '#FFA424');
            innerGradient.addColorStop(0.2, '#FEAE32');
            innerGradient.addColorStop(1, '#FBDA6C');
            this.ctx.fillStyle = innerGradient;
            this.ctx.fill();
            
            this.ctx.fillStyle = 'white';
            this.ctx.font = 'bold 12px HelveticaNeue';
            this.ctx.textAlign = 'center';
            this.ctx.textBaseline = 'middle';
            this.ctx.fillText('F', 12.5, 13);
            
            this.ctx.restore();
        },
        spin() {
            this.isSpinning = true;
            const extraRotations = 360 * 5;
            const randomDeg = Math.floor(Math.random() * 360);
            const targetRotation = this.currentRotation + extraRotations + randomDeg;
            
            // Анимация вращения
            const startTime = Date.now();
            const duration = this.duration;
            const startRotation = this.currentRotation;
            
            const animate = () => {
                const elapsed = Date.now() - startTime;
                const progress = Math.min(elapsed / duration, 1);
                
                // Функция замедления
                const easeOut = 1 - Math.pow(1 - progress, 3);
                
                this.currentRotation = startRotation + (targetRotation - startRotation) * easeOut;
                this.drawWheel();
                
                if (progress < 1) {
                    requestAnimationFrame(animate);
                } else {
                    this.determineWinner();
                    this.isSpinning = false;
                }
            };
            
            animate();
        },
        claim() {
            this.axios.post('SendRouletteResult', {member: true, data: {gift_amount: this.result.value}}).then(res => {
                if(res.data.body.result === '0') {
                    this.spinned = true;
                } else {
                    this.result = '';
                }
            });
        },
        determineWinner() {
            // Вычисляем какой сегмент указывает на указатель
            const normalizedRotation = this.currentRotation % 360;
            const segmentAngle = 360 / this.segments.length;
            
            // Указатель находится сверху (0 градусов), поэтому вычисляем индекс сегмента
            // Нужно учесть, что колесо вращается по часовой стрелке
            const segmentIndex = Math.floor((360 - normalizedRotation) / segmentAngle) % this.segments.length;
            
            const winningSegment = this.segments[segmentIndex];
            this.result = winningSegment;
        },
    }
}
</script>

<style lang="scss" scoped>
.wheel-container {
    position: relative;
    width: 264px;
    height: 264px;
    border-radius: 50%;
    text-align: center;
    box-sizing: content-box;
    background-clip: padding-box;

    .wheel-container-inner {
        position: absolute;
        top: -3px;
        left: -3px;
        width: 270px;
        height: 270px;
        background: linear-gradient(225deg, #FEDC31 16%, #FDC347 22.46%, #FC8682 35.39%, #FA2CD7 53.35%, #987CDB 70.59%, #33D0E0 87.83%);
        border-radius: 50%;
        z-index: 1;
    }
}

.canvas-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 264px;
    height: 264px;
    background: linear-gradient(225deg, #000604 16%, #303030 44.73%, #000604 87.83%);
    border-radius: 50%;
    z-index: 2;
}

canvas {
  border-radius: 50%;
  display: block;
  position: relative;
  z-index: 3;
  background: linear-gradient(135deg, #FEDC31 16.82%, #FDC347 22.71%, #FC8682 34.48%, #FA2CD7 50.84%, #987CDB 66.55%, #33D0E0 82.25%);
  background-clip: padding-box;
}

.indicator {
    position: absolute;
    top: -1px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
}

.spin-button {
  margin-top: 30px;
  padding: 15px 30px;
  font-size: 18px;
  font-weight: bold;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  
  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.w192 {
    width: 192px;
}

.w248 {
    width: 248px;
}

.blue-color {
    color: $main-pressed;
}
</style>